import { PaginatedResponse } from "@/interfaces/paginatedResponse";
import axios from "@/lib/axios";
import { useGroupHotelsStore } from "@/stores/groupHotels";
import { useQuery } from "@tanstack/vue-query";
import { storeToRefs } from "pinia";
import { ref, watch } from "vue";
import { Hotel } from "../../../../interfaces/Hotel";

interface Props {
  immediate?: boolean;
  params: Params;
}

interface Params {
  id: number | string;
}

const getBrandsHotel = async (
  params: Params,
): Promise<PaginatedResponse<Hotel>> => {
  const { data } = await axios.get<PaginatedResponse<Hotel>>(
    `/api/internal/brands/${params.id}/hotels`,
  );

  return data;
};

const useBrandsHotel = (props: Props) => {
  const { immediate = true, params } = props;

  const { setHotels } = useGroupHotelsStore();
  const { hotels } = storeToRefs(useGroupHotelsStore());
  const hotelGroupId = ref<number | string>(0);

  const setHotelGroupId = (id: number | string) => {
    hotelGroupId.value = id;
  };

  const { data, isLoading, refetch, isFetching } = useQuery(
    ["brands-hotel", hotelGroupId.value],
    () =>
      getBrandsHotel({
        id: hotelGroupId.value || props.params.id,
      }),
    {
      enabled: immediate,
    },
  );

  watch(
    data,
    (value) => {
      if (value) {
        setHotels(value.data.map((hotel) => ({ ...hotel, isChecked: false })));
      }
    },
    {
      immediate,
    },
  );

  return {
    data,
    isLoading,
    refetch,
    hotelGroupId,
    setHotelGroupId,
    isFetching,
    hotels,
  };
};

export default useBrandsHotel;
